import { useCallback } from 'react';
import { Connection } from '@/types/data';

interface Hub {
  hub: string;
  name: string;
}

export const useNodeCreation = () => {
  // Function to create nodes from hubs and connections
  const createNodesFromLocations = useCallback((hubs: Hub[], connections: Connection[]) => {
    // Create a set of hub IDs for quick lookup
    const hubIds = new Set(hubs.map((hub) => hub.hub));

    // Extract unique locations (hubs and zones)
    const uniqueLocations = new Set<string>();

    // Add all hubs to the uniqueLocations set
    hubs.forEach((hub) => {
      uniqueLocations.add(hub.hub);
    });

    // Add all locations from connections
    if (connections && connections.length > 0) {
      connections.forEach((conn) => {
        uniqueLocations.add(conn.start);
        uniqueLocations.add(conn.end);
      });
    }

    // Create nodes
    return Array.from(uniqueLocations).map((location) => {
      // Check if this location is a hub
      const isHub = hubIds.has(location);

      // Find the hub data if this is a hub
      const hubData = isHub ? hubs.find((hub) => hub.hub === location) : null;

      return {
        id: location,
        type: 'customNode', // Use our custom node type
        data: {
          label: location,
          type: isHub ? 'hub' : 'zone',
          description: hubData ? hubData.name : undefined,
        },
        position: { x: 0, y: 0 }, // Initial positions will be set by layout
      };
    });
  }, []);

  return {
    createNodesFromLocations,
  };
};
